<template>
  <div class="popup-body">
    <div class="content">
      <div class="drawer-notice-tab">
        <!------ group tabs -------->
        <ul class="tabs-head group-tabs">
          <li class="tabs-item" v-for="noticeGroup in noticeGroups">
            <a href="javascript:;"
               @click="loadNotice(noticeGroup)"
               :class="['tabs-link', noticeGroup.name === curTabName  && 'active']">{{ noticeGroup.text }}
                <span v-if="noticeGroup.name === 'unread' && unreadNum > 0" class="unread-num">{{ unreadNumStr }}</span>
            </a>
          </li>
        </ul>
        <div class="tabs-body" v-loading="loading">
          <div class="tabs-con" :style="{height: scrollHeight + 'px'}">
            <el-scrollbar ref="elScorller" :style="{height: scrollHeight + 16 + 'px'}" wrap-style="overflow-x:hidden;">
            <div class="drawer-notice-panel" v-if="noticeList && noticeList.length > 0">
              <!-- notice-cell -->
                <div :class="['notice-cell', notice.read && 'is-read']" v-for="notice in noticeList">
                  <div class="notice-element-head">
                    <span class="title" :title="notice.title">{{ notice.title }}</span>
                    <el-tooltip v-if="!notice.read" content="标记已读" :open-delay="tipsDeploy" placement="top">
                      <div class="icon tick" @click="updateNoticeStatus(notice, 'read')"><i class="mng icon-tick-stroke"></i></div>
                    </el-tooltip>
                    <el-tooltip :content="notice.star ? '取消星标' : '星标'" :open-delay="tipsDeploy" placement="top">
                      <div @click="updateNoticeStatus(notice, notice.star ? 'unstar' : 'star')" :class="['icon flag', notice.star && 'active'] "><i class="mng icon-star-stroke"></i></div>
                    </el-tooltip>
                    <el-tooltip content="删除" :open-delay="tipsDeploy" placement="top">
                      <div class="icon tools" @click="updateNoticeStatus(notice, 'delete')"><i class="mng icon-cross-simple"></i></div>
                    </el-tooltip>
                  </div>
                  <div class="notice-element-body">
                    <p class="info">{{ notice.content }}</p>
                    <span class="time">{{ formatDate(notice.createDate) }}</span>
                  </div>
                </div>
            </div>
            <div v-else class="empty fix-height">
              <div class="empty-wrap"><span class="empty-icon">
                <img src="/static/styles/images/no-notice.png"></span> <span
                class="empty-text">暂无通知消息哦</span></div>
            </div>
<!--              <div v-else class="no-notice">-->
<!--              无通知信息额~-->
<!--            </div>-->
            <div v-show="hasMore" class="load-more" @click="handleLoadMore">
              <i v-if="loadingMore" class="mng el-icon-loading"></i>
              <i v-else class="mng icon-dbarrow-down"></i>
            </div>
            </el-scrollbar>
          </div>
        </div>
        <!------ group tabs end -------->
      </div>
    </div>
  </div>
</template>

<script>
  import util from '../../libs/util'

  export default {
    name: 'notice-panel',
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      noticeGroups: {
        type: Array,
        default() {
          return []
        }
      },
      noticeList: {
        type: Array,
        default() {
          return []
        }
      },
      hasMore: {
        type: Boolean,
        default: false
      },
      loadingMore: {
        type: Boolean,
        default: false
      },
      curTabName: {
        type: String,
        default: 'all'
      },
      scrollHeight: {
        type: Number,
        default: document.documentElement.offsetHeight - 140
      },
      unreadNum: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        tipsDeploy: 800
      }
    },
    computed: {
      unreadNumStr() {
        return this.unreadNum < 100 ? this.unreadNum : '99+'
      }
    },
    methods: {
      formatDate(d) {
        return util.formatDate(new Date(d), 'yyyy-MM-dd HH:mm:ss')
      },
      updateNoticeStatus(notice, status) {
        this.$emit('notice-status-change', notice, status)
      },
      handleLoadMore() {
        if (!this.loadingMore) {
          this.$emit('load-more')
        }
      },
      loadNotice(noticeGroup) {
        this.$emit('load-notice', noticeGroup)
      },
      replaceExp(target) {
        // 替换内容中的超链接占位符
        // if (new RegExp(NOTICE_CONSTANT.urlRegStr).test(target)) {
        //   let match = target.match(NOTICE_CONSTANT.urlRegStr)
        //   for (let i = 0; i < match.length; i++) {
        //     // 拿到匹配到的字符串
        //     let m = match[i]
        //     let matchArr = m.replace('{a:', '').replace('}', '').split(':')
        //     let html = '<a href="' + util.baseUrl + matchArr[0] + '" class="downLink" target="_blank">' + matchArr[1] + '</a>'
        //     target = target.replace(m, html)
        //   }
        // }
        return target
      }
    },
    watch: {
      scrollHeight: function () {
        this.$nextTick(this.$refs.elScorller.update())
      }
    }
  }
</script>

<style lang="scss">

.notice-dropdown {
  .el-dropdown-menu__item {
    padding: 0;
    line-height: 1;
  }
}

.notice-more {
  z-index: 1;
  position: absolute;
  right: 46px;
  top: 16px;
  overflow: hidden;
  cursor: pointer;

  .el-dropdown {
    display: inline-block;
    position: relative;
    color: #606266;
    font-size: 0;
  }

  .btn {
    width: 24px;
    height: 24px;
    padding: 0;
    line-height: 24px;
    font-size: 0;
    color: #919395;
    vertical-align: middle;
    border: 1px solid transparent;
    border-radius: 4px;

    &:hover {
      color: inherit;
      background-color: #f3f5f7;
    }

    i {
      font-size: 13px;
      vertical-align: baseline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/drawer-notice/notice-panel.vue